import {createContext, useContext} from "react";
import {SubmissionApiClient} from "./submission/SubmissionApiClient";
import {FormSessionApiClient} from "./formsession/FormSessionApiClient";
import {UserApiClient} from "./user/UserApiClient";
import {CatalogApiClient} from "./catalog/CatalogApiClient";
import {SubmissionAuthorizationApiClient} from "./submission/SubmissionAuthorizationApiClient";
import {PaymentInformationApiClient} from "./payment/PaymentInformationApiClient";
import {PersonApiClient} from "./person/PersonApiClient";
import {IsdsMessageApiClient} from "./message/IsdsMessageApiClient";
import {IsdsMessageStateApiClient} from "./message-state/IsdsMessageStateApiClient";
import {StatisticsApiClient} from "./statistics/StatisticsApiClient";

export interface ApiClientLocator {
    catalogClient: CatalogApiClient;
    formSessionClient: FormSessionApiClient;
    isdsMessageClient: IsdsMessageApiClient,
    isdsMessageStateClient: IsdsMessageStateApiClient,
    paymentInformationApiClient: PaymentInformationApiClient;
    submissionAuthorizationClient: SubmissionAuthorizationApiClient;
    personClient: PersonApiClient;
    submissionClient: SubmissionApiClient;
    statisticsClient: StatisticsApiClient;
    userClient: UserApiClient;
}

export function useClientLocator() {
    const locator = useContext(ApiClientLocatorContext);
    if (locator) {
        return locator;
    } else {
        throw new Error("An API Client Locator context has not been provided");
    }
}

const ApiClientLocatorContext = createContext<ApiClientLocator | undefined>(undefined);
export default ApiClientLocatorContext;
